module.exports = __webpack_public_path__ + "img/icon-04@2x.9904f918.png";